import { useColorModeValue, useToast } from '@chakra-ui/react';
import { useCallback } from 'react';

import type { IToastOptions } from './types';

export const useCustomToast = () => {
	const toast = useToast();

	const showToast = useCallback(
		({ title, description, duration, isClosable, position, status = 'success' }: IToastOptions) => {
			toast({
				title: title,
				description: description,
				duration: duration ?? 9000,
				isClosable: isClosable ?? true,
				position: position ?? 'bottom-right',
				status,
			});
		},
		[toast]
	);

	return { showToast };
};

export const useIconColor = () => {
	return useColorModeValue('black', 'white');
};
